




















































import Enumerable from "linq";
import { Component, Mixins, Prop } from "vue-property-decorator";
import { NumberInput } from "../../../../../base/components/system";
import { OptionDropDownSelector } from "../../../../../base/components/system/selectors";
import { StandardOption } from "../../../../../base/components/system/selectors/mixins";
import { ICheckBehavior, PatientProfileCheckKinds } from "../../../../../documaker/domain/format/objects";
import { ModelEditableMixin } from "../../../../../base/components/system/mixins";

@Component({
  components: {
    NumberInput,
    OptionDropDownSelector,
  }
})
export default class CheckBehaviorEditor extends Mixins(ModelEditableMixin) {
  @Prop()
  isPatientProfileCheckKindSelectable: boolean;

  @Prop()
  kinds: PatientProfileCheckKinds[];

  @Prop()
  isGroupScopeSelectable: boolean;

  @Prop({default: () => ({
    isGroupScopePage: {
      isEnable: true,
    },
    isMultiCheckable: {
      isEnable: true,
    },
    isChecked: {
      isEnable: true,
    },
    pastedTextToCheck: {
      isEnable: true,
    },
    score: {
      isEnable: true,
    },
    patientProfile: {
      isEnable: true,
    },
  })})
  option: {
    isGroupScopePage: {
      isEnable: boolean;
    },
    isMultiCheckable: {
      isEnable: boolean;
    },
    isChecked: {
      isEnable: boolean;
    },
    pastedTextToCheck: {
      isEnable: boolean;
    },
    score: {
      isEnable: boolean;
    },
    patientProfile: {
      isEnable: boolean;
    },
  };

  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ICheckBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ICheckBehavior) => T, defaultValue: T) => T;

  get isChecked(): boolean {
    return this.readPropertyOrDefault(s => s.isChecked, true);
  }

  set isChecked(value: boolean) {
    this.writePropertyWhenValid(s => s.isChecked = value);
  }

  get isMultiCheckable(): boolean {
    return this.readPropertyOrDefault(s => s.isMultiCheckable, true);
  }

  set isMultiCheckable(value: boolean) {
    this.writePropertyWhenValid(s => s.isMultiCheckable = value);
  }

  get scoreOn(): number {
    return this.readPropertyOrDefault(s => s.score.on, 0);
  }

  set scoreOn(value: number) {
    this.writePropertyWhenValid(s => s.score.on = value);
  }

  get scoreOff(): number {
    return this.readPropertyOrDefault(s => s.score.off, 0);
  }

  set scoreOff(value: number) {
    this.writePropertyWhenValid(s => s.score.off = value);
  }

  get patientProfileKinds(): PatientProfileCheckKinds {
    return this.readPropertyOrDefault(s => s.patientProfileKinds, PatientProfileCheckKinds.None);
  }

  set patientProfileKinds(value: PatientProfileCheckKinds) {
    this.writePropertyWhenValid(s => s.patientProfileKinds = value);
  }

  get pastedTextToCheck(): string {
    return this.readPropertyOrDefault(s => s.pastedTextToCheck, "");
  }

  set pastedTextToCheck(value: string) {
    this.writePropertyWhenValid(s => s.pastedTextToCheck = value);
  }

  get isGroupScopePage(): boolean {
    return this.readPropertyOrDefault(s => s.isGroupScopePage, false);
  }

  set isGroupScopePage(value: boolean) {
    this.writePropertyWhenValid(s => s.isGroupScopePage = value);
  }

  patientProfileKindsOptions: StandardOption<number>[] = [
    new StandardOption<number>("設定対象にしない", PatientProfileCheckKinds.None),
    new StandardOption<number>("TRUE,FALSEを設定", PatientProfileCheckKinds.TrueOrFalse),
    new StandardOption<number>("初期選択値を設定", PatientProfileCheckKinds.defaultChecked),
    new StandardOption<number>("初期選択値を設定(未選択時は空)", PatientProfileCheckKinds.defaultCheckedOrEmpty),
  ];

  get kindsOptions(): StandardOption<number>[] {
    return Enumerable.from(this.kinds)
      .select(p => new StandardOption<number>(this.patientProfileKindsOptions[p].label, p))
      .toArray();
  }

  get formatNameWording(): string {
    return this.$wording.format.name;
  }

  correct(value: number): number {
    return value !== null ? Math.floor(value) : value;
  }

  isValid(value: number): boolean {
    return (0 <= value) || null;
  }
}
